"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutletOption = exports.IntervalState = exports.IntervalType = exports.OutletState = exports.DayOfWeek = void 0;
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek[DayOfWeek["Monday"] = 1] = "Monday";
    DayOfWeek[DayOfWeek["Tuesday"] = 2] = "Tuesday";
    DayOfWeek[DayOfWeek["Wednesday"] = 4] = "Wednesday";
    DayOfWeek[DayOfWeek["Thursday"] = 8] = "Thursday";
    DayOfWeek[DayOfWeek["Friday"] = 16] = "Friday";
    DayOfWeek[DayOfWeek["Saturday"] = 32] = "Saturday";
    DayOfWeek[DayOfWeek["Sunday"] = 64] = "Sunday";
    DayOfWeek[DayOfWeek["Everyday"] = 127] = "Everyday";
})(DayOfWeek = exports.DayOfWeek || (exports.DayOfWeek = {}));
var OutletState;
(function (OutletState) {
    /** @deprecated Use `Opened` instead */
    OutletState[OutletState["Open"] = 0] = "Open";
    OutletState[OutletState["Opened"] = 0] = "Opened";
    OutletState[OutletState["Closed"] = 1] = "Closed";
})(OutletState = exports.OutletState || (exports.OutletState = {}));
var IntervalType;
(function (IntervalType) {
    /** @deprecated Use `Normal` instead */
    IntervalType[IntervalType["Interval"] = 0] = "Interval";
    IntervalType[IntervalType["Normal"] = 0] = "Normal";
    IntervalType[IntervalType["Exception"] = 1] = "Exception";
})(IntervalType = exports.IntervalType || (exports.IntervalType = {}));
var IntervalState;
(function (IntervalState) {
    /** @deprecated Use `Opened` instead */
    IntervalState[IntervalState["Open"] = 0] = "Open";
    IntervalState[IntervalState["Opened"] = 0] = "Opened";
    IntervalState[IntervalState["Closed"] = 1] = "Closed";
})(IntervalState = exports.IntervalState || (exports.IntervalState = {}));
var OutletOption;
(function (OutletOption) {
    OutletOption[OutletOption["SendSMSToAppUsers"] = 1] = "SendSMSToAppUsers";
    OutletOption[OutletOption["CustomersFetchTableOrders"] = 2] = "CustomersFetchTableOrders";
})(OutletOption = exports.OutletOption || (exports.OutletOption = {}));
